import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Status } from '../../../common/constants';
import { deleteCapEndpointUrl } from '../../../config';
import api from '../../../api';
import { RootState } from '../../../store';

interface IDeleteCapEndpointState {
  status: string;
  error: string | null;
  msg: string | null;
}

const initialState: IDeleteCapEndpointState = {
  status: Status.IDLE,
  error: null,
  msg: null,
};

export const deleteCapEndpoint: any = createAsyncThunk(
  'deleteCapEndpoint',
  async (endpointId: string, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${deleteCapEndpointUrl}?endpointId=${endpointId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const deleteCapEndpointSlice = createSlice({
  name: 'deleteCapEndpoint',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteCapEndpoint.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
        state.error = null;
      })
      .addCase(deleteCapEndpoint.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.msg = action.payload?.message ?? null;
      })
      .addCase(deleteCapEndpoint.rejected, (state, action) => {
        const errorPayload = action.payload as { response?: { data?: { message?: string } } };
        state.status = Status.FAILED;
        state.error = errorPayload?.response?.data?.message || action.error.message || 'Unknown error';
      });
  },
});

export const selector = (state: RootState) => state.deleteCapEndpoint;
export default deleteCapEndpointSlice.reducer;
